import React from 'react';
import ReactDOMClient from 'react-dom/client';
import singleSpaReact from 'single-spa-react';

import Root from './Root.component';

export const { bootstrap, mount, unmount } = singleSpaReact({
    React,
    ReactDOMClient,
    rootComponent: Root,
    errorBoundary(err, errInfo) {
        console.error('cloud-nav: unhandled error', err, errInfo);
        return React.createElement('div');
    },
});
